import ace from './ace.js';

export default ace;
